import { useSelector } from 'react-redux';
import useHasPermission from '../../../helpers/hooks/useHasPermission';
var Checkbox = function Checkbox(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? uuid() : _ref$id,
    checked = _ref.checked,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? null : _ref$onChange,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$apiID = _ref.apiID,
    apiID = _ref$apiID === void 0 ? false : _ref$apiID,
    _ref$permission = _ref.permission,
    permission = _ref$permission === void 0 ? null : _ref$permission;
  var hasPermission = useHasPermission(permission);
  var activeApiCalls = useSelector(function (s) {
    return s.app.activeApiCalls;
  });
  var isDisabled = function isDisabled() {
    return disabled || false;
  };
  var isLoading = function isLoading() {
    return loading || (activeApiCalls === null || activeApiCalls === void 0 ? void 0 : activeApiCalls.find(function (x) {
      return x.id === apiID;
    })) || false;
  };
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: ['checkbox', className, isLoading() ? 'checkbox__loading' : ''].join(' '),
    style: style,
    onClick: function onClick() {
      if (hasPermission && !isDisabled() && !isLoading() && onChange) onChange(!checked);
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: checked,
    onChange: function onChange() {}
  }), /*#__PURE__*/React.createElement("div", {
    className: "checkbox__outer ".concat(checked && 'checkbox__outer--active')
  }, checked && /*#__PURE__*/React.createElement("div", {
    className: "checkbox__inner"
  })), (label || children) && /*#__PURE__*/React.createElement("div", {
    className: ['checkbox__label', isLoading() ? 'checkbox__loading' : ''].join(' ')
  }, label || children));
};
export default Checkbox;